import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export const BoxShadowWrapper = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 -23px 24px;
  padding: 0 1.5rem;

  ${props => css`
    ${props.theme.media.tablet`
    box-shadow: none;
    `};
    ${props.theme.media.desktop`
    border-radius: 24px 24px 0 0;
    margin: -26px -80px 24px;
    padding: 0 2rem;

    box-shadow: 0px 2px 4px -2px rgba(0, 0, 0, 0.1)
    `};
  `};
`;

BoxShadowWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
